const permission = {
  permissionList () {
    return new Promise((resolve, reject) => {
      let data = {
        super_admin: '超级系统管理',
        system: '系统管理',
        device: '设备管理',
        card: '卡片管理',
        people: '人员管理',
        product: '产品管理',
        order: '订单管理',
        production_plan: '生产计划管理',
        monitor: '实时监控',
        report_export: '报表输出'
      }
      resolve(data)
    })
  },

  permissionValue (value) {
    if (value === 1) {
      return '读'
    } else if (value === 2) {
      return '写'
    } else {
      return '读写'
    }
  }
}

export default permission



// WEBPACK FOOTER //
// ./src/api/permission.js